import { render, staticRenderFns } from "./input-selector.vue?vue&type=template&id=f3573b84&scoped=true"
import script from "./input-selector.vue?vue&type=script&lang=js"
export * from "./input-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3573b84",
  null
  
)

export default component.exports